
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import moment from 'moment'
import LineChart from '../LineChart/index.vue'

export type StudyRecordType = {
  // 学习时长 - h
  learnTime: number
  // 本周学习时长
  weekLearnTime: number
  // 学习开始时间
  learnStartTime: number
  // 学习结束时间
  learnEndTime: number
  // 最近一周学习数据
  lastWeekLearnData: Array<{
    // 学习时长
    time: number
    // 学习日期
    date: number
  }>
}

@Component({
  components: {
    LineChart
  }
})
export default class StudyRecord extends Vue {
  @Prop() dataSource: StudyRecordType

  // LineChart 组件配置
  get chartContent() {
    return {
      dataSource: this.dataSource.lastWeekLearnData.map(item => item.time),
      config: {
        lineWidth: 1,
        lineColor: '#F1E0E0',
        containerW: 275,
        containerH: 26,
        innerRadius: 1.5,
        outerRadius: 2.5,
        innerColor: '#F1E0E0',
        outerColor: '#D9A8A8'
      }
    }
  }
  // 连续学习时长
  get continueDays() {
    const { learnStartTime, learnEndTime } = this.dataSource

    return moment(learnEndTime).diff(moment(learnStartTime), 'day') + 1
  }
  // 数据更新时间
  get updateTime() {
    const cur = moment()
    const weekArr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

    return {
      updateTime: cur.format('YYYY.MM.DD'),
      updateWeekDay: weekArr[cur.day()]
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
